
(async () => {

  function convertToInternationalCurrencySystem (labelValue) {

    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e+9

    ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(1) + "B"
    // Six Zeroes for Millions 
    : Math.abs(Number(labelValue)) >= 1.0e+6

    ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(1) + "M"
    // Three Zeroes for Thousands
    : Math.abs(Number(labelValue)) >= 1.0e+3

    ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(1) + "K"

    : Math.abs(Number(labelValue));

  }
  
  function createCard(data) {
    const card = document.createElement('div');
    card.classList.add('col-auto', 'mb-0', 'px-1');
  
    card.innerHTML = `
      <div class="card p-0 mb-2" style="width: 10.5rem;" onmouseover="this.style.border='1px solid #5a626b';" onmouseout="this.style.border='none';">
        <div class="card-body p-1 pb-0">
          <div class="badge bg-soft-dark float-end">Rank #${data.Rank}</div>
          <p class="text-uppercase fs-12 mb-0"><a href="panda.html?id=${data.TokenId}">#${data.TokenId}</a></p>
          
        </div>
        <div class="card-body p-1">
          <div>
            <a href="panda.html?id=${data.TokenId}">
              <img src="https://prodftpserver.blob.core.windows.net/images/default/${data.TokenId}-1000x1000?r=${Math.floor(Math.random() * 100000)}" class="img-fluid panda-image"/>
            </a>
          </div>
        </div>
        <div class="card-body border-top p-1">
          <div class="row align-items-center justify-content-center">
            <div class="col-12">
              <ul class="list-inline mb-0">
                <li class="list-inline-item" style="width:100%;">
                  <a href="${data.Url}" target="_blank" class="text-muted d-flex align-items-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Buy now">
                    <button type="button" class="btn btn-white btn-xs" style="display: block;margin: 0 auto;width:100%;"><img src="assets/images/marketplaces/${data.Marketplace}.svg" width="18px" style="padding-right:5px;margin-left:-5px;"/>${data.PriceEth.toLocaleString(undefined,{ minimumFractionDigits: 0, maximumFractionDigits: 4 })} Ξ</button> 
                  </a>
                </li>
              </ul>
              <div class="d-flex justify-content-center">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item pe-0 me-1">
                    <a href="javascript:void(0)" class="text-muted d-flex align-items-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Panda Points">
                      <i class="uil uil-equal-circle" style="margin-right:2px;font-size: 0.7rem;"></i><span style="font-size: 0.75rem;">${convertToInternationalCurrencySystem(data.PointsBalance)}</span>
                    </a>
                  </li>
                  <li class="list-inline-item pr-0">
                    <a href="javascript:void(0)" class="text-muted d-flex align-items-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Points earned/day">
                      <i class="uil uil-plus-circle" style="margin-right:2px;font-size: 0.7rem;"></i><span style="font-size: 0.75rem;">${convertToInternationalCurrencySystem(data.PointsDaily)}</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="card-body border-top p-1 py-0 d-flex justify-content-center align-items-center">
          <div class="row align-items-center">
            <div class="col-sm-auto">
              <ul class="list-inline mb-0">
                <li class="list-inline-item">
                  <span style="font-size: 0.75rem;"><a href="javascript:void(0)" class="text-muted d-inline-block" data-bs-toggle="tooltip" data-bs-placement="bottom" title="PandaStats Value Score represents a panda's rank, points balance, inventory, and trait value relative to listing prices and recent sales.">
                    <b>Value Score:</b> <span>${data.ValueScore.toLocaleString(undefined,{ minimumFractionDigits: 0, maximumFractionDigits: 2 })}</span>
                  </a>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    `;
  
    const tooltips = card.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltips.forEach(function(tooltip) {
      new bootstrap.Tooltip(tooltip);
    });

    feather.replace();

    return card;
  }
  
  

  const fetchListings = async (orderBy = null, query = null) => {
    try { 
      if (localStorage.getItem('sortValue')) {
        sortValue = localStorage.getItem('sortValue');
      }

      console.log("orderBy:" + orderBy);
      console.log("sortValue: " + sortValue);

      orderBy = orderBy || sortValue;

      const sortMappings = {
        'Rank': 'rank',
        'Points Balance': 'pointsbalance desc,rank',
        'Value Score': 'valuescore desc,pointsbalance',
        'Points/day': 'pointsdaily desc,rank',
        'Highest Price': 'priceeth desc',
        'Lowest Price': 'priceeth,valuescore desc',
        'Recently Listed': 'createddate desc,valuescore desc'
      };

      const chart_container = document.querySelector('#listings-container-wrapper');
      chart_container.style.display = 'none';

      const spinner = document.querySelector('#loading-spinner-listings');
      spinner.style.display = 'block';

      const response = await axios.get('https://api.pandastats.io/listings?$orderBy=' + sortMappings[orderBy]);

      chart_container.style.display = 'block';
      spinner.style.display = 'none';

      
  
      if (response.status === 200) {
        var listings_table = response.data;      
        const container = document.querySelector('#listings-container'); 
        const limit = 50;

        if (query !== null) {
          listings_table = listings_table.filter(listing => listing.TokenId.toString().toLowerCase().includes(query.toLowerCase()));
        }
    
        let cards = [];
  
        for(let i = 0; i < limit && i < listings_table.length; i++) {
          const card = createCard(listings_table[i]);
          cards.push(card);
        }
  
        container.innerHTML = '';
        cards.forEach(card => container.appendChild(card));
        
        const loadMoreContainer = document.querySelector('.load-more-container');
        if (loadMoreContainer) {
          container.parentNode.removeChild(loadMoreContainer);
        }

        if(limit < listings_table.length) {
          const loadMoreButton = document.createElement('button');
          loadMoreButton.classList.add('btn', 'btn-primary', 'my-3');
          loadMoreButton.innerText = 'Load More...';
  
          const newLoadMoreContainer = document.createElement('div');
          newLoadMoreContainer.classList.add('text-center', 'mt-3', 'load-more-container');
  
          loadMoreButton.addEventListener('click', () => {
            const startIndex = cards.length;
            const endIndex = Math.min(startIndex + 25, listings_table.length);
            for(let i = startIndex; i < endIndex; i++) {
              const card = createCard(listings_table[i]);
              cards.push(card);
              container.appendChild(card);
            }
  
            if(endIndex >= listings_table.length) {
              loadMoreButton.style.display = 'none';
            }
          });
  
          newLoadMoreContainer.appendChild(loadMoreButton);
          container.parentNode.appendChild(newLoadMoreContainer);
        }
      } else {
        console.error('Error fetching data:', response.statusText);
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };
  
  let sortValue = document.querySelector('#listing-sort').value;

  // Reload listings on sort change
  document.querySelector('#listing-sort').addEventListener('change', (event) => {
    sortValue = event.target.value;
    localStorage.setItem('sortValue', sortValue);
    const orderBy = sortValue;
    const query = document.querySelector('#listing-search').value;
    fetchListings(orderBy, query);
  });

  document.querySelector('#listing-search').addEventListener('input', (event) => {
    const query = event.target.value;
    const orderBy = document.querySelector('#listing-sort').value;
    fetchListings(orderBy, query);
  });
  
  const sortingDropdown = document.querySelector('#listing-sort');
  if (localStorage.getItem('sortValue')) {
    const storedSortValue = localStorage.getItem('sortValue');
    for (let i = 0; i < sortingDropdown.options.length; i++) {
      if (sortingDropdown.options[i].value === storedSortValue) {
        sortingDropdown.selectedIndex = i;
        break;
      }
    }
  }

  // Initial fetch with default order
  fetchListings();
})();